import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { State, InvestorBalanceModel } from 'models';

import services from 'services';

import { BalanceAddonsDetails } from 'components';

interface BalanceAddonState {
  investorBalance: InvestorBalanceModel;
  loading: boolean;
  error: boolean;
}

const BalanceAddon = () => {
  const { coopId } = useSelector((state: State) => ({
    coopId: state.settings.current_cooperative,
  }));
  const [state, setState] = useState<BalanceAddonState>({
    investorBalance: {
      OverSaldo: 0,
      UnderSaldo: 0,
      Comments: null,
      ModifiedBy: null,
    },
    loading: false,
    error: false,
  });

  useEffect(() => {
    (async function () {
      try {
        setState((prevState) => ({
          ...prevState,
          loading: true,
          error: false,
        }));

        const investorBalance: InvestorBalanceModel = (
          await services.get(`/api/portfolios/${coopId}/dashboard/balances`)
        ).data.Data;

        setState((prevState) => ({
          ...prevState,
          loading: false,
          investorBalance,
        }));
      } catch (err) {
        console.error(err);

        setState((prevState) => ({
          ...prevState,
          loading: false,
          error: false,
        }));
      }
    })();
  }, [coopId]);

  return <BalanceAddonsDetails {...state} />;
};

export default BalanceAddon;
